import Eyebrow from "@components/services/Eyebrow";

interface SectionHeadProps {
  eyebrow: string;
  title: string;
  lede?: string;
  blue?: boolean;
  /** On a dark page background: white heading and lede, orange eyebrow. */
  inverse?: boolean;
  headingLevel?: "h2" | "h3";
}

function convertMarkdownLinksToHtml(text: string): string {
  return text.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2">$1</a>');
}

export default function SectionHead({
  eyebrow,
  title,
  lede,
  blue = false,
  inverse = false,
  headingLevel = "h2",
}: SectionHeadProps) {
  const normalizedLede = lede ? convertMarkdownLinksToHtml(lede) : "";
  const ledeContainsHtml = /<[^>]+>/.test(normalizedLede);
  const HeadingTag = headingLevel;

  return (
    <div className={inverse ? "section-head section-head--inverse" : "section-head"}>
      <Eyebrow text={eyebrow} blue={blue && !inverse} />
      <HeadingTag className="h-xl">
        {/<[^>]+>/.test(title) ? (
          <span dangerouslySetInnerHTML={{ __html: title }} />
        ) : (
          title
        )}
      </HeadingTag>
      {lede ? (
        ledeContainsHtml ? (
          <p className="lede" dangerouslySetInnerHTML={{ __html: normalizedLede }} />
        ) : (
          <p className="lede">{normalizedLede}</p>
        )
      ) : null}
    </div>
  );
}
